<template>
  <div>
    <v-alert type="info" prominent border="left" text dismissible>
      {{ $t('patientPortal.invoices.unavailable') }}
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {},
  data() {},
  computed: {},
  methods: {},
  mounted() {},
};
</script>
